export default __webpack_public_path__ + "static/media/css.df53a66b.svg";